import React, { useEffect, useState } from "react";
import { CREATE_RECIPIENTS_IN_CAMPAIGN_LINK } from "../../constants/constants";
import { notifyError, notifySuccess } from "../../helper";
import Header from "../Header";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import Tabs from "./Tabs";
import client from "../../api";
import FormValidator from "../../FormValidator";

const AddCampaign = () => {
    const api = client();
    const [contactEmails, setContactEmails] = useState();
    const [formData, setFormData] = useState({campaignname:'',contactEmailId:'',use_smtp:false});
    const [loading,setLoading] = useState(false);
    const [smtpAccount, setSmtpAccount] = useState([]);
    const [error, setError] = useState({});
    const validatorRules = {
        campaignname: {
            empty: "Please Enter Campaign Name"
        },
        contactEmailId:{
            empty: "Please Select Mail Account"
        }
    }
    const validatorObject = new FormValidator(validatorRules);
    
    const removeError = (e) => {
        setError({ ...error, [e.target.name]: "" });
    }

    const fieldBlur = e => {
        const fieldError = validatorObject.validateFields(e.target.value, e.target.name)
        if (Object.keys(fieldError).length) setError({ ...error, ...fieldError });        
    }

    const fieldFocus = e => {
        removeError(e);
        //update()
    }

    const validateAllFields = (inputs) => {
        const v = validatorObject.validateFields(inputs);
        if(Object.keys(v).length === 0){
            return true;
        } else {
            setError({...v});
            return false;
        }       
    }

    const hasSMTP = (item,value) => {
        return item.id === value;
    }

    const handleInputChange = (e) => {
        const {name,value}= e.target;
        if(name === 'use_smtp'){
            setFormData((prevData)=>({
                ...prevData,
                [name]:e.target.checked,
            }));
        } else {
            setFormData((prevData)=>({
                ...prevData,
                [name]:value,
            }));
        }
        if(name === 'contactEmailId'){
            const has_smtp = contactEmails.filter(item => hasSMTP(item, value));
            setSmtpAccount(has_smtp);
        }
    }

    const filterValues = (inputValues) => {
        return {
            name: inputValues.campaignname,
            assigned_to:inputValues.contactEmailId,
            current_tab:"add-recipients",
            completed_tabs:["start"],
            use_smtp: inputValues.use_smtp      
        }
    };
    
    const createCampaign = async () => {
        setLoading(true);
        try{
            if(validateAllFields(formData)){
                const filteredData = filterValues(formData);
                const response = await api.post('/v1/campaign/create',{
                    ...filteredData
                });
                
                if(response.status === 200 || response.status === 201){
                    setLoading(false);
                    if(typeof response.data.campaignID !== 'undefined'){
                        notifySuccess('Campaign Created Successfully...!');
                        const redirectUrl = CREATE_RECIPIENTS_IN_CAMPAIGN_LINK.replace(':campaignID',response.data.campaignID);
                        setTimeout(()=>{
                            window.location.href = redirectUrl;
                        },2500);
                    } else {
                        notifyError('Unable to create Campaign. Please try again');
                    }                    
                }
            } else {
                setLoading(false);
            }
        } catch (error){
            setLoading(false);
            if(error.status === 400) notifyError('Bad Request. Not able to create campaign. Please try again');            
        }        
    }

    useEffect(()=>{
        const getAllContactList = async () => {
            try{
                const response = await api.get('/v1/mailAccount/list');
                if(response.status === 200 || response.status === 201){
                    setContactEmails(response.data.data);
                }
            } catch(error){
                console.log('error.message',error);
                if(error.status === 400){
                    notifyError('Bad Request. Not able to fetch Contact Emails. Please try again');
                }  
            }
        }
    getAllContactList();
    },[]);
    
    return(<>
        <Header/>
        <div className="main-page">
            <Sidebar/>
           <div className="campaign-create-steps">
                <div className="top-section">
                    <h1>Add Campaign </h1>                
                </div>
                <div className="steps-wrap">
                    <Tabs currentTab="start" completedTabs={[]} />
                    <div className="step-start">
                        <h2>Let's get started!</h2>
                        <div className="step-forms">
                            <div className="field-wrap">
                                <label className="label-xs"> Title (for your team's eyes only)</label>
                                <input 
                                    type="text"
                                    name="campaignname" 
                                    placeholder="Campaign Title"
                                    value={formData.campaignname}
                                    onChange={handleInputChange}
                                    onBlur={fieldBlur}
                                    onFocus={fieldFocus} 
                                />
                                {error.campaignname && <span className="validation-error">{error.campaignname}</span>}
                            </div>
                            <div className="field-wrap">
                                <label className="label-xs"> From address </label>
                                <select 
                                    className="selectbox" 
                                    name="contactEmailId"
                                    onChange={handleInputChange}
                                    onBlur={fieldBlur}
                                    onFocus={fieldFocus}
                                    value={formData.contactEmailId}
                                    >
                                    <option value={''}>Select a From Address</option>
                                    {contactEmails && contactEmails.map((value,index)=> (<option key={index} value={value.id}>{value.email}</option>))}
                                </select>
                                {error.contactEmailId && <span className="validation-error">{error.contactEmailId}</span>}
                            </div>
                            {(smtpAccount.length && smtpAccount[0].has_smtp) ? <div className="field-wrap">                                
                                <label className="label-xs center" htmlFor="use-smtp"> 
                                    <input 
                                        type="checkbox" 
                                        name="use_smtp" 
                                        id="use-smtp" 
                                        onChange={handleInputChange}
                                        />  Use SMTP 
                                </label>
                            </div>:''}
                            <div className="field-wrap align-center">
                                <button 
                                    type="button" 
                                    className={loading ? "next-btn button--loading":"next-btn"}
                                    onClick={()=>createCampaign()}>
                                        <span className="button--text">Next</span>
                                </button>
                            </div>
                        </div>            
                    </div>                                             
                </div>
           </div>            
        </div>
        <Footer/>
    </>);
}

export default AddCampaign;